<template>
  <div class="content">
    <div :class="{bg: true,empty: list.length === 0}">
      <div class="batch">
        <img :src="checkedAll ? checkerOn : checker" class="checker" alt="checker" @click="selectAllChecker()">
        <div class="bigBtn greenBtn" @click="approveChecks()">
          批量通过
        </div>
        <div class="bigBtn" @click="banChecks()">
          批量退回
        </div>
      </div>
      <div class="headline">
        <div class="titles">
          <!-- <img :src="checker" class="checker" alt="checker"> -->
           <div class="checker"></div>
          <span class="topic">选题名称</span>
          <span class="reporter">执行人</span>
          <span class="locate">部门</span>
          <span class="publish">发布时间</span>
          <span class="handles">操作</span>
        </div>
      </div>
      <empty :mTop="30" :msg="`暂无${$_syscfg.interview}数据`" v-if="list && list.length === 0" />
      <div class="items" v-for="(i, d) in list" :key="d">
        <div class="item">
          <img v-show="i.view_scope == 1" class="lock" src="../../assets/img/newTopic/lock.png" alt="">
          <img :src="i.checked? checkerOn :checker" class="checker" alt="checker" @click="selectChecker(i)">
          <div class="topic">
            <p class="words" @click="goDetail(i.id)" :title="i.title">
              {{i.title}}
            </p>
            <img src="@assets/img/interview/new.svg" alt="new" v-if="i.is_new == 1">
          </div>
          <div class="reporter">
            <!-- {{i.reporters.map(j => {return j.name}).join(',')}} -->
            {{ i.executor_name }}
          </div>
          <div class="locate">{{i.depart_name}}</div>
          <div class="publish">{{i.date}}</div>
          <div class="handles">
            <span class="smallBtn" @click="goEdit(i.id)">编辑</span>
            <span class="smallBtn greenBtn" @click="handleInterviews([i.id], 2)">通过</span>
            <span class="smallBtn" @click="handleInterviews([i.id], 1)">退回</span>
          </div>
        </div>
      </div>
      <pages :page_count="page.page_count" :index="page.pageIndex" :total="page.total"></pages>
    </div>
  </div>
</template>

<script>
import pages from '@components/pages'
import common from '@common/common'
import {apis} from '@common/config'
import empty from '@components/empty'

export default {
  name: 'checkInterviews',
  components: {
    pages, empty
  },
  data() {
    return {
      page: {
        page_count: 0,
        pageSize: 10,
        pageIndex: 1,
        total: 0
      },
      checkedAll: false,
      checker: require('@assets/img/interview/checker.svg'),
      checkerOn: require('@assets/img/interview/checkerOn.svg'),
      list: [],
      searchOptions: {}
    }
  },
  methods: {
    showCard(id, e) {
      if (id == 0) return

      const el = e.target

      this.$card(id, el)
    },
    async goEdit(i) {
      const newWindow = window.open()
      const checkWindowClosed = setInterval(() => {
        if (newWindow.closed) {
          this.getList()
          clearInterval(checkWindowClosed); // Stop the interval once the window is closed
        }
      }, 1000);
      // newWindow.location.href = `${window.location.origin}/index.html#/newTopicEdit?r=${i}&type=change`
      common.checkPageStatus(i, 6).then(r => {
        if (r) {
          newWindow.location.href = `${window.location.origin}/newTopicEdit?r=${i}&type=change`
        } else {
          newWindow.close()
        }
      })
    },
    goDetail(i) {
      // this.$router.push({
      //   path: '/interviewCheck',
      //   query: {
      //     r: i,
      //     c: 't'
      //   }
      // })

      common.jump(`/newTopicDetail?r=${i}&c=t`, true)
    },
    getList(keyWord) {
      const id = this.$route.params.id
      const info = {
        idstring: id,
        search_option: '',
        key_words: '',
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      }

      if(keyWord == 'noKeyWord'){
        this.searchOptions.key_words = ''
      }else{  
        this.searchOptions.key_words = this.$store.state.keyWord
      }

      Object.assign(info, this.searchOptions)
      common.myFetch(apis.newTopicVerifylist, info)
      .then((data) => {
        this.list = data.list
        if(data.params && data.params.top_search){
          this.generateSearchs(data.params.top_search.option.list)
        }
        
        if(data.page && data.page.row_count){
          this.$set(this.page, 'page_count', common.calculatePage(data.page.row_count - 0, this.page.pageSize))
          this.$set(this.page, 'total', data.page.row_count - 0)
        }
      })
    },
    generateSearchs(data) {
      const types = data.map((i) => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected
        }
      })

      const filterData = {
        types: types,
        callback: (o) => {
          this.getSearch(o)
        }
      }

      this.postSearch(filterData)
    },
    getSearch(d) {
      this.searchOptions = d
      this.page.pageIndex = 1
      this.getList()
    },
    postSearch(data) {
      this.$emit('filterData', data)
    },
    selectChecker(i) {
      this.$set(i, 'checked', !i.checked)
    },
    selectAllChecker() {
      this.list.forEach((i) => {
        this.$set(i, 'checked', !this.checkedAll)
      })
      this.checkedAll = !this.checkedAll
    },
    async handleInterviews(ids, status) {
      let msg = '确认通过吗？'
      if (status === 1) {
        msg = '确认退回吗？'
      }
      const c = await this.$confirm(msg)
      if (!c) return

      const info = {
        ids: ids.join(','),
        status: status
      }

      common.myFetch(apis.newTopicVerify, info)
      .then((data) => {
        if (data) {
          this.$toast(data)
          this.getList()
        }
      })
    },
    allChecks() {
      const selected = []
      this.list.forEach((i) => {
        if (i['checked']) {
          selected.push(i.id)
        }
      })

      return selected
    },
    banChecks() {
      const ids = this.allChecks()
      this.handleInterviews(ids, 1)
    },
    approveChecks() {
      const ids = this.allChecks()
      this.handleInterviews(ids, 2)
    }
  },
  mounted() {
    this.getList('noKeyWord')
  }
}
</script>

<style lang="less" src="@assets/css/newTopic/checkInterviews.less" scoped></style>
